import { makeScalarToken } from '@utils/css';

const aspectRatio = makeScalarToken("--aspect", "0.75");
const box = "_35sb19r4l1z";
const printWrapper = "_35sp1eceepo";
const printThumbnail = "_35sp1i0mq1k";
const printPlayIcon = "_35sp1ulv8jm";

export { aspectRatio, box, printPlayIcon, printThumbnail, printWrapper };
import "./input.video.style.linaria.module.css";
//# sourceMappingURL=input.video.style.js.map
